import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M17.112 6H6.886A.875.875 0 0 0 6 6.865v10.268c0 .478.396.867.886.867h10.226c.49 0 .888-.39.888-.865V6.865A.877.877 0 0 0 17.112 6M9.56 16.226H7.78v-5.728H9.56zm-.89-6.509a1.032 1.032 0 1 1-.004-2.063 1.032 1.032 0 0 1 .004 2.063m7.556 6.509h-1.78V13.44c0-.663-.01-1.518-.925-1.518-.926 0-1.066.724-1.066 1.472v2.83h-1.777v-5.727h1.706v.783h.024c.237-.45.818-.926 1.683-.926 1.802 0 2.135 1.186 2.135 2.728z"
    }, null, -1)
  ])))
}
export default { render: render }